import React, { useState } from "react";
import { useScrollAnimation } from "../../utils/Utils";
import { toast } from 'react-toastify'
import COUNTRIES from '../../utils/COUNTRIESLIST'
import ListOfAdresses from "./ListOfAdresses";
import hq from "../../Assets/contactus/location.png";
const AnotherContactUs = () => {
  const [formData, setFormData] = useState({
    fullname: "",
    company: "",
    jobtitle:"",
    workemail: "",
    country: "",
    countrycode: "",
    mobilenumber: "",
    nicheindustry: "",
    hearUs:"",
    about: "",
    agreement: false,
  });

  
  const [errors, setErrors] = useState({});
  

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
     console.log(e)
    // If country is selected, automatically set the country code
    if (name === "country") {
      const selectedCountry = COUNTRIES.find(country => country.code === value);
      setFormData({
        ...formData,
        [name]: value,
        countrycode: selectedCountry ? selectedCountry.dialCode : "",
      });
    } else {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value,
      });
    }
  
    // Validate the input field while typing
    validateField(name, value, type === "checkbox" ? checked : value);
  };
  // Field validation for live error checking
  const validateField = (name, value, checked) => {
    let error = "";
  
    switch (name) {
      case "fullname":
        if (!value) error = "Full Name is required";
        break;
  
      case "company":
        if (!value) error = "Company Name is required";
            break;
        case "jobtitle":
        if (!value) error = "JobTitle  is required";
        break;
  
      case "workemail":
        if (!value) {
          error = "Work Email is required";
        } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) {
          error = "Email address is invalid";
        }
        break;
  
      case "country":
        if (!value) error = "Country is required";
        break;
  
      case "countrycode":
        if (!value) error = "Country Code is required";
        break;
  
      case "mobilenumber":
        if (!value) {
          error = "Mobile Number is required";
        } else if (!/^\d+$/.test(value)) {
          error = "Mobile Number must contain only digits";
        } 
       
        break;
  
      case "nicheindustry":
        if (!value) error = "Niche Industry is required";
        break;
  
      case "about":
        if (!value) error = "Please tell us how we can help you";
        break;
  
      case "agreement":
        if (!checked) error = "You must accept the agreement";
        break;
  
      default:
        break;
    }
  
    setErrors((prevErrors) => {
      if (error) {
        return { ...prevErrors, [name]: error }; // Set error if validation fails
      } else {
        const { [name]: removedError, ...rest } = prevErrors; // Remove error if validation passes
        return rest;
      }
    });
  };
  
  // Validation for all fields on submit
const validate = () => {
    let formErrors = {};
  
    // Full Name Validation
    if (!formData.fullname) formErrors.fullname = "Full Name is required";
  
    // Company Validation
      if (!formData.company) formErrors.company = "Company Name is required";
  // job title validation
       if (!formData.jobtitle) formErrors.jobtitle = "Job Title is required";
  
    // Work Email Validation
    if (!formData.workemail) {
      formErrors.workemail = "Work Email is required";
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.workemail)) {
      formErrors.workemail = "Email address is invalid";
    }
  
    // Country Validation
    if (!formData.country) formErrors.country = "Country is required";
  
    // Country Code Validation
    if (!formData.countrycode) formErrors.countrycode = "Country Code is required";
  
    // Mobile Number Validation
    if (!formData.mobilenumber) {
      formErrors.mobilenumber = "Mobile Number is required";
    } else if (!/^\d+$/.test(formData.mobilenumber)) {
      formErrors.mobilenumber = "Mobile Number must contain only digits";
    } 
    
  
    // Niche Industry Validation
    if (!formData.nicheindustry)
          formErrors.nicheindustry = "Niche Industry is required";
        // Niche Industry Validation
    if (!formData.hearUs)
          formErrors.hearUs = "How Did You Hear Us is required";
  
    // About Validation
    if (!formData.about)
      formErrors.about = "Please tell us how we can help you";
  
    // Agreement Validation
    if (!formData.agreement)
      formErrors.agreement = "You must accept the agreement";
  
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  
  };

 

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (validate()) {
       
        console.log("Form data submitted:", formData);

        toast.info("Submitting your inquiry...   ", {
            position:"top-right",
            autoClose: 10000, // Auto-close after 10 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });
      
        try {
           
          const response = await fetch('https://kapil-api-backend.onrender.com/api/sendMail', {
        method: 'POST', 
        headers: {
            'Content-Type': 'application/json', 
        },
        body: JSON.stringify(formData), 
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json(); // Parse the JSON from the response
    console.log(data); // Handle the response data as needed
          
              setFormData({
                fullname: "",
                company: "",
                jobtitle:"",
                workemail: "",
               country: "",
               countrycode: "",
               mobilenumber: "",
               nicheindustry: "",
               hearUs:"",
               about: "",
               agreement: false,
               })
       // Show success message using Toastify
            toast.success("Email sent successfully!", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "light",
            });
            console.log('Success:', response.data); // Handle success response

        } catch (error) {
          console.error('Error submitting form:', error); // Handle error
          
          toast.error("Error sending email. Please try again.", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "light",
            });
        }
    } else {
      console.log("Validation errors:", errors);
        
          toast.error("Please fix the validation errors.", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "light",
            });
    }
};

  const [activeLink, setActiveLink] = useState("america");
  console.log("activelink", activeLink);
  const handleNavLinkClick = (link) => {
    setActiveLink(link);
  };


  useScrollAnimation();

  return (
    <div>
      <section className="">
        <div className=" contant_main"></div>
  
        <div
          className="  grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-10 xl:mx-40 mx-3 md:mx-6 relative  -top-[7rem]
"
        >
          {/* Form Section */}
          <div className="lg:col-span-2 col-span-1 shadow-lg p-8 bg-[#fff] rounded-md animate-up">
            <h2 className="text-darkblue text-2xl font-bold mb-2">
              Contact Us
            </h2>
            <h3 className="text-lg text-gray-700 mb-4">
              Tell us a Little About Yourself
            </h3>
            <form onSubmit={handleSubmit}>
              {/* Form Fields */}
              <div className="grid md:grid-cols-2 gap-6 mt-5">
                <div className="w-full">
                  <input
                    type="text"
                    name="fullname"
                    id="name"
                    value={formData.fullname}
                    className="contact_form w-full p-3 rounded-md shadow-sm border"
                    placeholder="Full Name"
                    onChange={handleChange}
                  />

                  <div className="h-3">
                    {errors.fullname && (
                      <span className="text-xs text-red ">
                        {errors.fullname}
                      </span>
                    )}
                  </div>
                </div>
                <div className="w-full">
                  <input
                    type="text"
                    name="company"
                    id="company"
                    className="contact_form w-full p-3 rounded-md shadow-sm border"
                    placeholder="Company Name"
                    value={formData.company}
                    onChange={handleChange}
                  />

                  <div className="h-3">
                    {errors.company && (
                      <span className="text-xs text-red ">
                        {errors.company}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-6 mt-5">
                <div className="w-full">
                  <input
                    type="email"
                    id="email"
                    name="workemail"
                    className="contact_form w-full p-3 rounded-md shadow-sm border"
                    value={formData.workemail}
                    placeholder="Work Email"
                    onChange={handleChange}
                  />
                  <div className="h-3">
                    {errors.workemail && (
                      <span className="text-xs text-red ">
                        {errors.workemail}
                      </span>
                    )}
                  </div>
                 </div>
                <div className="w-full">
                  <input
                    type="text"
                    name="jobtitle"
                    id="jobtitle"
                    className="contact_form w-full p-3 rounded-md shadow-sm border"
                    placeholder="Job Title"
                    value={formData.jobtitle}
                    onChange={handleChange}
                  />

                  <div className="h-3">
                    {errors.jobtitle && (
                      <span className="text-xs text-red ">
                        {errors.jobtitle}
                      </span>
                    )}
                  </div>
                </div>
                
                          </div>
                          
             <div className="grid md:grid-cols-2 gap-6 mt-5">
                <div className="w-full">
                  <select
                    id="country"
                    name="country"
                    className="contact_form w-full p-3 rounded-md shadow-sm border text-gray-600"
                    value={formData.country}
                    onChange={handleChange}
                  >
                    <option value="" disabled>Select Country</option>
                    {COUNTRIES.map((country) => (
                      <option key={country.code} value={country.code}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                  <div className="h-3">
                    {errors.country && (
                      <span className="text-xs text-red-500">
                        {errors.country}
                      </span>
                    )}
                  </div>
                </div>
                <div className="w-full">
                  <div className="flex">
                    <div className="w-1/3 mr-2">
                      <input
                        type="text"
                        name="countrycode"
                        readOnly
                        className="contact_form w-full p-3 rounded-md shadow-sm border bg-gray-100 text-gray-600"
                        value={formData.countrycode}
                        placeholder="Code"
                      />
                    </div>
                    <div className="w-2/3">
                      <input
                        type="tel"
                        name="mobilenumber"
                        className="contact_form w-full p-3 rounded-md shadow-sm border"
                        value={formData.mobilenumber}
                        placeholder="Mobile Number"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="h-3">
                    {errors.mobilenumber && (
                      <span className="text-xs text-red-500">
                        {errors.mobilenumber}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6 mt-5">
                
              </div>
              <div className="grid md:grid-cols-2 gap-6 mt-5">
                <div className="w-full mb-2">
                  <input
                    type="text"
                    id="nicheindustry"
                    name="nicheindustry"
                    className="contact_form w-full p-3 rounded-md shadow-sm border"
                    placeholder="Niche Industry"
                    value={formData.nicheindustry}
                    onChange={handleChange}
                  />
                  <div className="h-3">
                    {errors.nicheindustry && (
                      <span className="text-xs text-red ">
                        {errors.nicheindustry}
                      </span>
                    )}
                  </div>
                              </div>
                 <div className="w-full">
                  <select
                    id="hearUs"
                    name="hearUs"
                    className="contact_form w-full p-3 rounded-md shadow-sm border"
                    value={formData.hearUs}
                    onChange={handleChange}
                  >
                    <option value="" disabled selected>
                      How Did You Hear Us
                    </option>
                    <option>Media Article</option>
                    <option>Partner Connect</option>
                    <option>Social Media Post</option>
                    <option>Web Search</option>
                    <option>Word Of Mouth</option>
                    <option>Others</option>
                                      
                    
                  </select>
                  <div className="h-3">
                    {errors.country && (
                      <span className="text-xs text-red ">
                        {errors.hearUs}
                      </span>
                    )}
                  </div>
                </div>            
                
           
              </div>
              <div className="w-full mb-5 mt-5">
                <textarea
                  id="message"
                  rows="4"
                  name="about"
                  placeholder="Please tell us how we can help you..."
                  value={formData.about}
                  className="contact_form w-full p-3 rounded-md shadow-sm border"
                  onChange={handleChange}
                ></textarea>
                <div className="h-3">
                  {errors.about && (
                    <span className="text-xs text-red ">{errors.about}</span>
                  )}
                </div>
              </div>
              <div className="flex items-center ">
                <input
                  id="agreement"
                  type="checkbox"
                  name="agreement"
                  className="w-4 h-4 text-blue-600 bg-gray-200 border-gray-300 rounded focus:ring-blue-500"
                  checked={formData.agreement}
                  onChange={handleChange}
                />
                <label
                  htmlFor="agreement"
                  className="ml-2 text-sm font-medium text-gray-900"
                >
                  By submitting this form, you acknowledge that KCS
                  Technologies may use your personal information for marketing
                  communications as outlined in its privacy policy.
                  <span className="text-red">*</span>
                </label>
              </div>
              <div className="h-3">
                {errors.agreement && (
                  <span className="text-xs text-red ">{errors.agreement}</span>
                )}
              </div>
              <button
                type="submit"
                className="border mt-7 bg-[#4e8ecb] rounded-md py-2 px-4 text-[#fff] mb-2 "
              >
                Submit
              </button>
            </form>
          </div>

         


          <div className="shadow-lg p-8 bg-white rounded-md animate-up">
  <h2 className="text-darkblue text-2xl font-bold mb-4">
    Connect with Us
  </h2>
 
            <img src={hq} alt="head quaters" className="h-28 m-auto"/>
  {/* Headquarters Section */}
  <div className="mb-6 p-4 border-l-4 border-blue-600 bg-blue-50">
    <h3 className="text-lg font-bold text-blue-800 mb-2">Global Headquarters</h3>
    <div className="flex items-start mb-3">
      <svg
        className="w-6 h-6 text-blue-600 mt-1 flex-shrink-0"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M8.25 6.75v1.5m0 1.5V15m0 1.5v1.5m0-13.5v-1.5a2.25 2.25 0 0 1 2.25-2.25h3.75A2.25 2.25 0 0 1 16.5 4.5v1.5m-8.25 0h8.25"
        />
      </svg>
      <div className="ml-3">
        <span className="font-medium text-gray-800 block">BSD Green Office Park 1, 6th Floor</span>
        <span className="text-gray-700 block">Jl. BSD Green Office Park, BSD City</span>
        <span className="text-gray-700 block">Tangerang 15345, Indonesia</span>
      </div>
    </div>
  </div>
  
  {/* Contact Details */}
  <h3 className="text-lg font-semibold text-gray-800 mb-3">Contact Information</h3>
  <div className="flex items-center mb-4">
    <svg
      className="w-6 h-6 text-blue-600 flex-shrink-0"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
      />
    </svg>
    <span className="text-gray-700 ml-3">info@ptkcs.com</span>
  </div>
  
  <div className="flex items-center mb-4">
    <svg
      className="w-6 h-6 text-blue-600 flex-shrink-0"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75A2.25 2.25 0 0 0 15.75 1.5h-2.25v2.25h-3V1.5z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M15 12H9"
      />
    </svg>
    <div className="ml-3">
      
      <span className="text-gray-700 block ">Indonesia: +62 85218084208</span>
    </div>
  </div>
  
  <p className="text-gray-600 mt-6">
    We typically respond within one business day. Your satisfaction is
    our top priority.
  </p>
</div>
     </div>
      </section>
         <section>
        <ListOfAdresses/>
      </section>
    </div>
  );
};

export default AnotherContactUs;


